import { render, staticRenderFns } from "./FinishClaim.vue?vue&type=template&id=56860a56&"
import script from "./FinishClaim.vue?vue&type=script&setup=true&lang=js&"
export * from "./FinishClaim.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./FinishClaim.vue?vue&type=style&index=0&id=56860a56&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports